import React from 'react';
import PurchaseLanding from '../components/PurchaseLanding';

const PurchasePage: React.FC = () => {
  return <PurchaseLanding />;
};

export default PurchasePage;